import { Box, Checkbox, Dialog, DialogContent, InputAdornment, Pagination, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { farmers, region, taskAssign } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { addPisciculture, deletePisciculture, editPisciculture, getTypeOfPiscicultureExcel, importTypeOfPiscicultureExcel, pisciculture, piscicultureBulkDelete, } from "../../config/services";
import { Button } from "../../components/Button/button";
import { downloadFile } from "../../config/DownloadFile";
import translations from "../../config/language";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const PiscicultureData = () => {
  const navigate = useNavigate();
  const [editCategory, setEditCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);
  const [addCategory, setAddCategory] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [piscicultureData, setPiscicultureData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [addCategoryData, setAddCategoryData] = useState("");
  const [editCategoryData, setEditCategoryData] = useState("");
  const [editId, setEditId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedpiscicultureTable, setSelectedpiscicultureTable] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [importExcelLoading, setImportExcelLoading] = useState(false);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const location = useLocation();
  const param = useParams();
  const cropName = location.state?.name;

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Types Of Pisiciculture" && module.is_editor === true
  ) ? true : false;
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        setSelectedFile(file);
      } else {
        notifyError(translations[language].pleaseSelectExcelFile || 'Please select an Excel file');
        event.target.value = null; // Reset file input
      }
    }
  };

  useEffect(() => {
    handleGetPiscicultureData();
  }, [currentPage]);

  const handleGetPiscicultureData = async () => {
    try {
      const resp = await pisciculture(param.id, currentPage, perPage);
      if (resp.status == 200 || resp.status == 201) {
        setPiscicultureData(resp?.data?.results?.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      setPiscicultureData([]);
    }
  };
  const filteredPisciculture = piscicultureData.filter((crop) =>
    crop.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddData = async (event) => {
    event.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }

    if (!addCategoryData) {
      notifyError("Please enter Piscuiculture");
      return true;
    }

    const params = {
      name: addCategoryData,
      type_of_pisciculture: param.id,
    };

    try {
      setIsLoading(true);
      const resp = await addPisciculture(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setAddCategory(false);
        handleGetPiscicultureData();
        setAddCategoryData("");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setAddCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      setAddCategoryData("");
    }
  };
  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setAddCategory(false); // Closes the popup
    setEditCategory(false);
    setAddCategoryData("");
    setDeleteCategory(false);
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handleEditPopup = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setEditCategory(true);
    setEditCategoryData(e.name);
  };

  const handleEditCategory = async (event) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!editCategoryData) {
      notifyError("Please enter Piscuiculture");
      return true;
    }

    event.preventDefault();
    const params = {
      name: editCategoryData,
      type_of_pisciculture: param.id,
    };

    try {
      setIsLoading(true);
      const resp = await editPisciculture(params, editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setEditCategory(false);
        handleGetPiscicultureData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setEditCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleDeletePopup = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setDeleteCategory(true);
  };

  const handleDeleteDta = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setIsLoading(true);
      const resp = await deletePisciculture(editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setDeleteCategory(false);
        handleGetPiscicultureData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setDeleteCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedpiscicultureTable((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  // Function to handle "Select All"
  const handleSelectAll = () => {
    if (selectedpiscicultureTable.length === filteredPisciculture.length) {
      setSelectedpiscicultureTable([]); // Uncheck all
    } else {
      setSelectedpiscicultureTable(filteredPisciculture.map((e) => e.id)); // Select all
    }
  };

  const handleBulkDelete = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setBulkDeleteLoading(true);

    const params = {
      ids: selectedpiscicultureTable
    }

    try {
      const resp = await piscicultureBulkDelete(params);

      if (resp.data.success) {
        notifySuccess(resp.data.message);

        handleGetPiscicultureData();
        setSelectedpiscicultureTable([]);

      }
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);


    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setSelectedpiscicultureTable([]);
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);
    }
  }

  const language = process.env.REACT_APP_LANGUAGE;

  const handleDemoFile = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      pisciculture_type_id: Number(param.id)
    };
    try {
      const res = await getTypeOfPiscicultureExcel(params);
      if (res.data.success == true) {
        downloadFile(res);
        notifySuccess(translations[language].downloadSuccess);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response?.data?.message || translations[language].downloadFailed);
    }
  }

  const handleImportExcel = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedFile) {
      notifyError(translations[language].pleaseSelectFile);
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("pisciculture_type_id", param.id);

    try {
      setImportExcelLoading(true);
      const resp = await importTypeOfPiscicultureExcel(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        handleGetPiscicultureData();
        setImportExcel(false);
        setSelectedFile(null);
        setImportExcelLoading(false);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setImportExcel(false);
      setSelectedFile(null);
      setImportExcelLoading(false);
    }
  }
  return (
    <>
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/pisciculture")}
            />
            <img src={region.region} alt="" />
            <Typography variant="h6" gutterBottom>
              {cropName}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ cursor: bulkDeleteLoading ? "not-allowed" : "pointer", marginRight: "10px" }}
              disabled={bulkDeleteLoading}
              onClick={() => handleBulkDelete()}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }} onClick={() => handleDemoFile()}>
              {translations[language].demoFile}
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setImportExcel(true)
              }
              }
            >
              {translations[language].importExcel}
            </button>

            <button
              className="assign-task-btn"
              style={{ marginLeft: "0px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setAddCategory(true)
              }
              }
            >
              {translations[language].addPisciculture}
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder={translations[language].searchHere}
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  {translations[language].search}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <div className="crop-table-container">
          <Table className="region-table pt-1" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                    checked={selectedpiscicultureTable.length === filteredPisciculture.length}
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell style={{ width: "100px", textAlign: "center" }}>
                  {translations[language].srNo}
                </TableCell>
                <TableCell>{cropName} Name</TableCell>
                <TableCell style={{ width: "100px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPisciculture.length > 0 ? (
                filteredPisciculture?.map((e, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell>
                        <Checkbox
                          sx={{
                            color: "rgba(225, 230, 244, 1)",
                            borderRadius: "4px",
                            "&.Mui-checked": {
                              color: "rgba(199, 206, 227,1)",
                            },
                          }}
                          checked={selectedpiscicultureTable.includes(e.id)}
                          onChange={() => handleRowSelect(e.id)}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {" "}
                        {i + 1 + (currentPage - 1) * perPage}
                      </TableCell>
                      <TableCell>{e.name}</TableCell>
                      <TableCell>
                        <div className="d-flex gap-3">
                          <img
                            src={region.editIcon}
                            alt=""
                            onClick={() => handleEditPopup(e)}
                            style={{ cursor: "pointer", height: "23px" }}
                          />
                          <img
                            src={region.deleteIcon}
                            alt=""
                            onClick={() => handleDeletePopup(e)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={4} style={{ textAlign: "center" }}>
                    <img src={farmers.noData} alt="No Data" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          className="pagination"
        >
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addCategory}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addPisciculture}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterPisciculture}
                name="addCategoryData"
                value={addCategoryData}
                className="mb-3"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setAddCategoryData(value);
                  }
                }}
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  {translations[language].cancel}
                </button>

                <Button
                  title={translations[language].addPisciculture}
                  classname={"assign-task-button"}
                  onClick={handleAddData}
                  loading={isLoading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editCategory}
          // onClose={() => setEditCategory(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].editPisciculture}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Pisciculture"
                name="taskTitle"
                value={editCategoryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setEditCategoryData(value);
                  }
                }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  {translations[language].cancel}
                </button>
                <Button
                  title={translations[language].updatePisciculture}
                  classname={"assign-task-button"}
                  onClick={handleEditCategory}
                  loading={isLoading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteCategory}
          // onClose={() => setDeleteCategory(false)}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>{translations[language].deletePisciculture}</b>
            </Typography>
            <Typography
              variant="p"
              className="pt-4"
              style={{ fontSize: "16px" }}
            >
              {translations[language].deletePiscicultureConfirmation}
            </Typography>
            <div className="d-flex gap-3 pt-4">
              <Button
                title={translations[language].yes}
                classname={"assign-task-button"}
                onClick={handleDeleteDta}
                loading={isLoading}
              />
              <button className="assign-task-button" onClick={handleCancel}>
                {translations[language].no}
              </button>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          // onClose={() => setImportExcel(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].importExcel}
              </h5>
            </div>
          </div>
          <DialogContent>
            <Box textAlign="center">
              <input
                type="file"
                accept=".xlsx, .xls"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  {selectedFile ? (
                    <Box textAlign="center">
                      <img
                        src={region.browseImage}
                        alt="Excel"
                        style={{ width: 50, height: 50, marginBottom: 8 }}
                      />
                      <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                        {selectedFile.name}
                      </Box>
                      <Box sx={{ fontSize: "12px", color: "#555" }}>
                        {(selectedFile.size / 1024).toFixed(1)} KB
                      </Box>
                    </Box>
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setImportExcel(false);
                  }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={(e) => handleImportExcel(e)}
                  style={{ cursor: importExcelLoading ? "not-allowed" : "pointer" }}
                  loading={importExcelLoading}
                  disabled={importExcelLoading}
                >
                  {translations[language].submit}
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default PiscicultureData;
